import { Col, HeadingText, Row } from '@paypalcorp/pp-react'
import React, { useEffect } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import { MORE_WAYS_OF_HELP_DATA } from '../../utils/prop-type-shape'
import { componentNames, fptiTypes } from '../../utils/analytics/fpti-constants'
import HelpOption from '../help-option'

import './more-ways-of-help.less'
import useTracking from '../../hooks/useTracking'
// MoreWaysOfHelp Component - To display help contact channels
function MoreWaysOfHelp({ helpChannels }) {
  const { trackActivity } = useTracking()

  // On component mount
  useEffect(() => {
    trackActivity({
      name: componentNames.MORE_WAYS_OF_HELP,
      type: fptiTypes.SUCCESS,
    })
  }, [])

  const isHelpChannelsExist = () => {
    return Array.isArray(helpChannels) && helpChannels.length
  }

  const renderHelpOptions = () => {
    return (
      isHelpChannelsExist() && (
        <>
          <Row noGutters={true} data-testid="hc-more-ways-section">
            <Col>
              <HeadingText
                data-testid="hc-more-ways-heading"
                className="more-help-options__heading"
                as="h2"
                size="lg"
              >
                <Message id="app.helpcenter.moreWaysToHelp" />
              </HeadingText>
            </Col>
          </Row>
          <Row
            noGutters={true}
            className="more-help-options"
            data-testid="hc-more-ways-help-options"
          >
            {helpChannels.map((helpChannel) => (
              <HelpOption key={helpChannel.id} {...helpChannel} />
            ))}
          </Row>
        </>
      )
    )
  }

  return <>{renderHelpOptions()}</>
}

MoreWaysOfHelp.propTypes = MORE_WAYS_OF_HELP_DATA

export default MoreWaysOfHelp
